import axios from 'axios';
import { useUserStore } from '@/stores/user'
import { useIdleStore } from '@/stores/idle'
import { showNotification } from '@/utils/notifications'
/*import { useLayoutStore } from "@/stores/layout.js";*/

// URL dinámica: detecta el dominio automáticamente
axios.defaults.baseURL = `${window.location.origin}/api/v1/`;

// Evitar múltiples redirecciones a login cuando varias peticiones reciben 401 a la vez
let redirectingToLogin = false;

// Evitar que el toast de 429 se apile si llegan varios seguidos
let showing429Toast = false;

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const retryRequest = async (config, attempt = 1) => {
    const maxAttempts = 3;
    const delay = Math.min(1000 * Math.pow(2, attempt - 1), 8000); // 1s, 2s, 4s

    if (attempt > maxAttempts) {
        return Promise.reject(new Error('Max retries reached after 429'));
    }

    await sleep(delay);

    return axios(config);
};

const urlsExcludedForBearerHeader = [
  '/auth/login',
  '/login',
  '/register',
  '/password-recovery',
  '/password-reset',
  '/sl',
];

axios.interceptors.request.use(
  (request) => {
    const userStore = useUserStore();

    if (urlsExcludedForBearerHeader.indexOf(request.url) === -1) {
      request.headers['accept-language'] = localStorage.getItem("locale") ?? "es_ES";
      request.headers.Authorization = `Bearer ${userStore.token}`;
    }

    // Enviar socket ID para que broadcast()->toOthers() excluya solo esta conexión
    if (window.Echo?.socketId?.()) {
      request.headers['X-Socket-Id'] = window.Echo.socketId();
    }

    return request;
  },
  (err) => Promise.reject(err)
);

axios.interceptors.response.use(
  (response) => {

    /*const layoutStore = useLayoutStore();

    // Do something with response data
    layoutStore.isFormModified = false;*/

    return response.data;
  },
  async (error) => {
    if (error.response) {
      if (error.response.status === 429) {
        const config = error.config;
        config._retryCount = (config._retryCount || 0) + 1;

        if (config._retryCount <= 3) {
            if (!showing429Toast) {
                showing429Toast = true;
                showNotification({ type: 'warning', message: 'Demasiadas peticiones simultáneas, reintentando...' });
                setTimeout(() => { showing429Toast = false; }, 5000);
            }
            return retryRequest(config, config._retryCount);
        }

        // Si agotamos reintentos, notificamos y rechazamos
        showNotification({ type: 'error', message: 'Demasiadas peticiones. Espera unos segundos antes de continuar.' });
        return Promise.reject(error);
      }

      if (error.response.status === 401) {
        // No interceptar 401 en peticiones marcadas como reauth del idle
        if (error.config?._isIdleReauth) {
          return Promise.reject(error);
        }

        if (redirectingToLogin) {
          return Promise.reject(error);
        }
        redirectingToLogin = true;
        const userStore = useUserStore();
        const idleStore = useIdleStore();
        userStore.setLogout();
        idleStore.stopWatching();
        idleStore.$reset();
        window.location.href = '/login';
        return Promise.reject(error);
      }
    } else {
      console.log('Error sin respuesta del servidor, revisar la conexión o problemas de red');
    }

    return Promise.reject(error);
  }
);